import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    CREATE_PRODUCT_DETAILS_FAILURE,
    CREATE_PRODUCT_DETAILS_FORM,
    CREATE_PRODUCT_DETAILS_REQUEST,
    CREATE_PRODUCT_DETAILS_SUCCESS,
    DELETE_PRODUCT_DETAILS_FAILURE,
    DELETE_PRODUCT_DETAILS_REQUEST,
    DELETE_PRODUCT_DETAILS_SUCCESS,
    FETCH_PRODUCT_DATA_FROM_PROPERTY_FAILURE,
    FETCH_PRODUCT_DATA_FROM_PROPERTY_REQUEST,
    FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS,
    FETCH_PRODUCT_DETAILS_BY_ID_FAILURE,
    FETCH_PRODUCT_DETAILS_BY_ID_REQUEST,
    FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS,
    FETCH_PRODUCT_DETAILS_FAILURE,
    FETCH_PRODUCT_DETAILS_REQUEST,
    FETCH_PRODUCT_DETAILS_SUCCESS,
    FETCH_SINGLE_PRODUCT_DETAILS_FAILURE,
    FETCH_SINGLE_PRODUCT_DETAILS_REQUEST,
    FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS,
    RESET_PRODUCT_DETAILS_INFO,
    UPDATE_PRODUCT_DETAILS_FAILURE,
    UPDATE_PRODUCT_DETAILS_REQUEST,
    UPDATE_PRODUCT_DETAILS_SUCCESS
} from './productDetails.actionType';

// FETCH ALL PRODUCT DETAILS DATA
export let fetchProductDetails = () => {
    let config = {
        method: 'get',
        url: ConstantApi.productDetailsGET,
        responseTypeRequest: FETCH_PRODUCT_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_PRODUCT_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_PRODUCT_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// FETCH PRODUCT DETAILS DATA
export let fetchProductDetailsWithIdData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.productDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_PRODUCT_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_PRODUCT_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};

// CREATE PRODUCT DETAILS FORM
export let createProductDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_PRODUCT_DETAILS_FORM, payload: { key, value } });
    };
};

// CREATE PRODUCT DETAILS
export let createProductDetails = (formData, modalClose, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldFkId: parseInt(formData.fldFkId),
        fldFKProductType: parseInt(formData.fldFKProductType)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.productDetailsPOST}`,
        responseTypeRequest: CREATE_PRODUCT_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_PRODUCT_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_PRODUCT_DETAILS_FAILURE,
        resetFormData: RESET_PRODUCT_DETAILS_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProductDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// GET SINGLE PRODUCT DETAILS
export let getSingleProductDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.productDetailsGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_PRODUCT_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_PRODUCT_DETAILS_FAILURE,
        singlApiArray: [fetchProductTypeFromProperty()]
    };
    return axiosCall(config);
};

//UPDATE PRODUCT DETAILS
export let updateProductDetails = (formData, id) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldFkId: parseInt(formData.fldFkId),
        fldFKProductType: parseInt(formData.fldFKProductType)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.productDetailsPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_PRODUCT_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_PRODUCT_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_PRODUCT_DETAILS_FAILURE,
        resetFormData: RESET_PRODUCT_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProductDetailsWithIdData(id)
    };
    return axiosCall(config);
};

// DELETE PRODUCT DETAILS
export let deleteProductDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.productDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_PRODUCT_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_PRODUCT_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_PRODUCT_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchProductDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// FETCH PRODUCT TYPE DATA
export let fetchProductTypeFromProperty = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/35`,
        responseTypeRequest: FETCH_PRODUCT_DATA_FROM_PROPERTY_REQUEST,
        responseTypeSuccess: FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS,
        responseTypeFailure: FETCH_PRODUCT_DATA_FROM_PROPERTY_FAILURE
    };
    return axiosCall(config);
};
